import { theme } from '@algoan/deep-dive/theme';
import { ComponentProps } from '@algoan/deep-dive/model';

export interface LineIconProps extends ComponentProps {
  id?: string;
  color?: string;
}

export const LineIcon = ({ id, color, ...props }: LineIconProps): JSX.Element => {
  return (
    <svg id={id} width="10" height="2" viewBox="0 0 10 2" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <line y1="0.9" x2="10" y2="0.9" stroke={color ?? theme.white} strokeWidth="1.2" />
    </svg>
  );
};
